import { Box, Link, SxProps, Typography } from '@mui/material';
import { BackButton } from 'components/Buttons';
import { Button } from 'system/atoms';
import { Input } from 'components/Inputs';
import { FormikProps } from 'formik';
import React from 'react';
import {
  whatsAppOnboardingStepMapper,
  WhatsAppOnboardingSteps,
  YAY_GUIDE_URL,
  YAY_URL
} from '../constants';
import { getSupportUrl } from 'core/utils/supportUrl';

const buttonsContainer: SxProps = {
  mt: 2,
  display: 'flex'
};

type Props = {
  handleNext: (step?: number) => void;
  handleBack: () => void;
  formik: FormikProps<{ phoneNumber: string }>;
};

export const WhatsAppPhoneNumberStep: React.FC<Props> = ({
  handleBack,
  handleNext,
  formik
}) => {
  return (
    <Box>
      <BackButton onClick={handleBack} />

      <Box mt={3}>
        <Typography variant="body1">
          You may add a phone number you own or{' '}
          <Link
            href={getSupportUrl({ ticketForm: 'purchase_a_mobile_number' })}
            target="_blank"
          >
            request one from the Popp support team.
          </Link>{' '}
          Adding an existing number will allow you to get started today.
        </Typography>

        <Typography variant="body1" mt={1}>
          <strong>Note:</strong>
          <ul>
            <li>
              This number must NOT be currently linked to a WhatsApp account.
            </li>
            <li>
              You can purchase a number from a provider such as{' '}
              <Link href={YAY_URL} target="_blank" rel="noreferrer">
                Yay
              </Link>{' '}
              (follow the steps in{' '}
              <Link href={YAY_GUIDE_URL} target="_blank" rel="noreferrer">
                this guide
              </Link>
              ).
            </li>
          </ul>
        </Typography>
        <Input
          id="phoneNumber"
          name="phoneNumber"
          subLabel="Include the country code e.g. +44"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={
            Boolean(formik.errors.phoneNumber) && formik.touched.phoneNumber
          }
          errorText={formik.errors.phoneNumber}
          value={formik.values.phoneNumber}
        />
      </Box>

      <Box sx={buttonsContainer}>
        <Button
          onClick={() => {
            if (formik.errors.phoneNumber || !formik.values.phoneNumber) {
              formik.setTouched({ phoneNumber: true });
              return;
            }

            handleNext(
              whatsAppOnboardingStepMapper[
                WhatsAppOnboardingSteps.LOGIN_TO_META
              ]
            );
          }}
          variant="primary"
        >
          Next
        </Button>

        <Button
          variant="secondary"
          onClick={() =>
            handleNext(
              whatsAppOnboardingStepMapper[
                WhatsAppOnboardingSteps.USER_WITH_NO_PHONE_NUMBER
              ]
            )
          }
        >
          I don't have a phone number
        </Button>
      </Box>
    </Box>
  );
};
